<div class="checkbox-container">
  <span class="input-container">
    <mat-checkbox [formControl]="control" [disabledInteractive]="true">
      <span [innerHTML]="label || '' | translate | iconReplace"></span>
    </mat-checkbox>
  </span>
</div>
